// extracted by mini-css-extract-plugin
export default {"component":"SplashScreen_component__LEGlk","bottomContainer":"SplashScreen_bottomContainer__mXWcZ"};